export default "__VITE_ASSET__BLbAQclX__"